@if(error) {
  <div class="alert alert-danger">{{ error }}</div>
}
<div class="span9">
  <h1 data-automation-name="schedulerIndex">Scheduler</h1>
</div>

<p class="lead">
  Jobs in external Venway Scheduler service. Sorted by the most recent to the oldest.
</p>
<div class="span3" style="text-align:right;">
  <a id="createSchedulerTask" class="btn btn-large btn-primary" (click)="nextPage($event, '/createSchedulerTask', router)" style="margin-top:9px;">Add New Task</a>
</div>

<table class="table table-striped">
  <thead>
  <tr>
    <th>Name</th>
    <th>Callback URL</th>
    <th>Rate (seconds)</th>
    <th>Start</th>
    <th>Type</th>
    <th></th>
    <th></th>
  </tr>
  </thead>
  <tbody>
    @for(task of displayedTasks | paginate: paginationModel; track task) {
      <tr class="table-active">
        <td>{{task.name}}</td>
        <td>{{task.params.url}}</td>
        <td>{{task.rate}}</td>
        <td>{{task.start}}</td>
        <td>{{task.type}}</td>
        <td>
          <a id="edit" class="btn btn-default" (click)="nextPage(task.name, '/editSchedulerTask', router)" name="editTask">Edit</a>
        </td>
        <td>
          <button id="delete" class="btn btn-danger" type="button" (click)="delete(task)">Delete</button>
        </td>
      </tr>
    }
    @if(displayedTasks.length <= 0) {
      <tr>
        <td colspan="7" style="text-align: center;"> No job statuses to display.</td>
      </tr>
    }
  </tbody>
  <tfoot>
  <tr>
    <td class="text-center" colspan="7">
      <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
    </td>
  </tr>
  </tfoot>
</table>

<!-- The commented code for job history from Venway2 is not included as it was commented out in the original -->
